module.exports = __webpack_public_path__ + "static/media/37@2x.ba52f38c.png";